import type { PropsWithChildren } from 'react';

const CompareModelsTable = ({ children }: PropsWithChildren) => {
  return (
    <div role="table">
      <div className="flex flex-col gap-y-5" role="rowgroup">
        {children}
      </div>
    </div>
  );
};

export default CompareModelsTable;
